import React from 'react';
import { motion } from 'framer-motion';
import { useGentleMotion as useReducedMotion } from '../hooks/useGentleMotion';
import { StarIcon, QuoteIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { testimonials } from '../data/content';
const tints = ['#E6F2FB', '#FFF7E4', '#FDEAEC'];
function Stars({
  delay = 0
}: {
  delay?: number;
}) {
  const reduce = useReducedMotion();
  return <div className="flex gap-0.5" role="img" aria-label="5 de 5 estrellas" data-id="element-299" data-mp="36z97ain8bpwa">
      {Array.from({
      length: 5
    }).map((_, i) => <motion.span key={i} animate={reduce ? undefined : {
      scale: [1, 1.18, 1]
    }} transition={{
      duration: 2.4,
      repeat: Infinity,
      repeatDelay: 1.6,
      delay: delay + i * 0.1,
      ease: 'easeInOut'
    }} data-id="element-300" data-mp="31z37gf6t2x34" data-mpi={i}>
          <StarIcon className="h-4 w-4 fill-sun text-sun" aria-hidden="true" data-id="element-301" data-mp="v8wuwec8fset" />
        </motion.span>)}
    </div>;
}
export function Testimonials() {
  return <section className="w-full bg-white py-16 sm:py-20" aria-labelledby="testimonials-title" data-id="element-302" data-mp="h5oq3c5zm87y">
      <div className="mx-auto max-w-content px-5 sm:px-8" data-id="element-303" data-mp="m5b5ns9ag0jx">
        <Reveal data-id="element-304" data-mp="m2omswgy5yme">
          <h2 id="testimonials-title" className="text-center font-display text-2xl font-extrabold uppercase leading-tight text-navy sm:text-4xl" data-id="element-305" data-mp="780jnoz0rc9y">
            Lo que dicen <span className="text-sky" data-id="element-306" data-mp="zwfv61ixzcgj">las familias</span>
          </h2>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3" data-id="element-307" data-mp="zyseai0frsv6">
          {testimonials.map((t, i) => <Reveal as="article" key={i} delay={i * 0.08} data-id="element-308" data-mp="q6wd2y31zmmq" data-mpi={i}>
              <figure className="relative flex h-full flex-col rounded-3xl p-6 transition-transform duration-300 hover:-translate-y-1.5 motion-reduce:transition-none motion-reduce:hover:translate-y-0" style={{
            backgroundColor: tints[i % tints.length]
          }} data-id="element-309" data-mp="q6cv5hdeky8p">
                <QuoteIcon className="absolute right-5 top-5 h-8 w-8 opacity-20" style={{
              color: t.accent
            }} aria-hidden="true" data-id="element-310" data-mp="1nnbleu7r1zlo" />
                <Stars delay={i * 0.3} data-id="element-311" data-mp="1sjpbitzjtbds" />
                <blockquote className="mt-4 flex-1 font-sans text-sm leading-relaxed text-ink" data-id="element-312" data-mp="1oh2l8xiizyip">
                  “{t.quote}”
                </blockquote>
                <figcaption className="mt-5 flex items-center gap-3" data-id="element-313" data-mp="1jhyaw3jv7uqs">
                  {t.avatar ? <img src={t.avatar} alt="" className="h-10 w-10 rounded-full object-cover" width={80} height={80} loading="lazy" decoding="async" data-id="element-314" data-mp="1el7uff45ex4u" /> : <span className="flex h-10 w-10 items-center justify-center rounded-full font-display text-xs font-extrabold text-white" style={{
                backgroundColor: t.accent
              }} aria-hidden="true" data-id="element-315" data-mp="vswvfwcm7jc0">
                      {t.initials}
                    </span>}
                  <span data-id="element-316" data-mp="3cf3lgz8j4wey">
                    <span className="block font-display text-sm font-extrabold text-navy" data-id="element-317" data-mp="3cek53myj2g31">
                      {t.name}
                    </span>
                    {t.country && <span className="block font-sans text-xs text-muted" data-id="element-318" data-mp="2jqo9klkp2u7u">{t.country}</span>}
                  </span>
                </figcaption>
              </figure>
            </Reveal>)}
        </div>

        {/* Editable social proof zone — fill in only with real data. */}
        <Reveal delay={0.1} data-id="element-319" data-mp="2xickwmn4denr">
          <div className="mx-auto mt-10 max-w-2xl rounded-3xl bg-cream2 p-6 text-center" data-id="element-320" data-mp="2xim9q6wfhfrv">
            <p className="font-sans text-sm text-muted" data-id="element-321" data-mp="20yvhquhd3f1p">
              <strong className="font-semibold text-navy" data-id="element-322" data-mp="251iaqyprr60h">365 ideas</strong> ·{' '}
              <strong className="font-semibold text-navy" data-id="element-323" data-mp="24z5jtw219lba">10 bonos</strong> ·{' '}
              <strong className="font-semibold text-navy" data-id="element-324" data-mp="1lx6hdtv9hhth">Garantía 7 días</strong> ·{' '}
              <strong className="font-semibold text-navy" data-id="element-325" data-mp="1gzdb70tyknt7">Acceso inmediato</strong>
            </p>
            <p className="mt-3 font-sans text-[11px] leading-relaxed text-muted/70" style={{
            fontWeight: "400"
          }} data-id="element-326" data-mp="1vo9hotgd9srp">
               ★★★★★ 4.9/5 · Más de 300 familias ya disfrutan las actividades · criarcon_imaginación + 10K de seguidores en instagram

            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}